import { PenLine } from 'lucide-react';
import { useOrgContext } from '@/hooks/useOrgContext';
import ConsentSender from '@/components/admin/ConsentSender';

// 2026-08-15 (Wayne review): sending a consent is a DAILY clinical function,
// not administration. Own rail surface; identity comes from patient select.
export function SendConsentRoute() {
    const { org_id: orgId } = useOrgContext();
    return (
        <div className="min-h-full bg-pt-darker">
            <header className="border-b border-pt-border/60 px-6 py-4 flex items-center gap-3">
                <span className="text-pt-cyan"><PenLine className="w-5 h-5" /></span>
                <div>
                    <h1 className="text-lg font-display font-semibold text-pt-text">Send Consent</h1>
                    <p className="text-xs text-pt-text-muted">E-sign forms for an existing patient — email or iPad</p>
                </div>
            </header>
            <div className="p-6">
                {orgId ? <ConsentSender orgId={orgId} /> : <div className="text-sm text-pt-text-muted">Loading…</div>}
            </div>
        </div>
    );
}
